// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#allmap[data-v-5d2d7f82]{width:20rem;height:20rem;margin:4.63vw auto}.text[data-v-5d2d7f82]{height:1.25rem;color:red;line-height:1.25rem}", ""]);
// Exports
module.exports = exports;
